import React from "react"
import PropTypes from "prop-types"
import { Box } from "@mui/material"

import { overviewCardsGridSx2 } from "./constants/overviewGrid"
import EacCostCard from "./EacCostCard"
import EacVsObjectiveCard from "./EacVsObjectiveCard"

const ForecastSection = ({ data, isLoading }) => {
  return (
    <Box sx={{ width: "100%" }}>
      <Box sx={overviewCardsGridSx2}>
        <EacCostCard
          eac_cost={data?.eac_cost ?? 0}
          isLoading={isLoading}
          currency={data?.currency}
        />
        <EacVsObjectiveCard
          costObjective={data?.eacVsObjectiveCard?.costObjective ?? 0}
          deviation={data?.eacVsObjectiveCard?.deviation ?? 0}
          deviationPercent={data?.eacVsObjectiveCard?.deviationPercent ?? null}
          isLoading={isLoading}
          currency={data?.currency}
        />
      </Box>
    </Box>
  )
}

ForecastSection.propTypes = {
  data: PropTypes.shape({
    currency: PropTypes.string,
    eac_cost: PropTypes.number,
    eacVsObjectiveCard: PropTypes.shape({
      costObjective: PropTypes.number,
      deviation: PropTypes.number,
      deviationPercent: PropTypes.oneOfType([
        PropTypes.number,
        PropTypes.oneOf([null]),
      ]),
    }),
  }),
  isLoading: PropTypes.bool.isRequired,
}

export default ForecastSection
